import { toJS } from '../../iterable/toJS';

export function shapeOperationsForAPI({ operations }) {
  function reduceOperations(result, source) {
    const operation = toJS(source);

    if ('ai' in operation) {
      delete operation.ai;
    }

    result.push(operation);
    return result;
  }

  return operations.reduce(reduceOperations, []);
}
